import { Modal, Table, ScrollArea, Loader } from "@mantine/core";

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${day}/${month}/${year} `;
};

const DisplayOrder = ({ order, opened, onClose }) => {
  if (!order) {
    return <Loader />;
  }

  return (
    <Modal opened={opened} onClose={onClose} title="Détails de la Commande" size="xl" centered>
      <ScrollArea style={{ height: 500 }}>
        <Table withTableBorder withColumnBorders verticalSpacing="sm">
          <Table.Tbody>
            <Table.Tr>
              <Table.Td>N° commande/appel</Table.Td>
              <Table.Td>{order.order_number}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Description commande/appel</Table.Td>
              <Table.Td>{order.order_description}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Source de la commande</Table.Td>
              <Table.Td>{order.order_source}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Entité opérationnelle</Table.Td>
              <Table.Td>{order.operational_entity}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Réf. affaire commande/appel</Table.Td>
              <Table.Td>{order.order_reference}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Mode de consultation</Table.Td>
              <Table.Td>{order.consultation_mode}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Date de création</Table.Td>
              <Table.Td>{order.creation_date && formatDate(order.creation_date)}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Date fermeture définitive</Table.Td>
              <Table.Td>{order.final_closure_date && formatDate(order.final_closure_date)}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Date du besoin de livraison de ligne</Table.Td>
              <Table.Td>{order.delivery_need_date && formatDate(order.delivery_need_date)}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Date dernière réception</Table.Td>
              <Table.Td>{order.last_reception_date && formatDate(order.last_reception_date)}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Délai d'exécution des travaux commande/appel</Table.Td>
              <Table.Td>{order.execution_delay}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Statut d'avancement</Table.Td>
              <Table.Td>{order.advancement_status}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Statut d'approbation</Table.Td>
              <Table.Td>{order.approval_status}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Indice Annulation commande</Table.Td>
              <Table.Td>{order.cancellation_index}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Indice Invest/exploitation commande/appel</Table.Td>
              <Table.Td>{order.investment_exploitation_index}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>N° DA</Table.Td>
              <Table.Td>{order.da_number}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Direction pilote DA</Table.Td>
              <Table.Td>{order.da_pilot_direction}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Émetteur DA</Table.Td>
              <Table.Td>{order.da_issuer}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Prescripteur DA</Table.Td>
              <Table.Td>{order.da_prescriber}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>N° marché</Table.Td>
              <Table.Td>{order.market_number}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Numéro fournisseur</Table.Td>
              <Table.Td>{order.supplier_number}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>SIRET</Table.Td>
              <Table.Td>{order.siret}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Numéro Siren</Table.Td>
              <Table.Td>{order.siren}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Adresse du Site</Table.Td>
              <Table.Td>{order.site_address}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Ville du site</Table.Td>
              <Table.Td>{order.site_city}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Code postal du site</Table.Td>
              <Table.Td>{order.site_postal_code}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Compte</Table.Td>
              <Table.Td>{order.account}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Société</Table.Td>
              <Table.Td>{order.company}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Centre</Table.Td>
              <Table.Td>{order.center}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Activité</Table.Td>
              <Table.Td>{order.activity}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Équipement</Table.Td>
              <Table.Td>{order.equipment}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Centre CF</Table.Td>
              <Table.Td>{order.cf_center}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Destination</Table.Td>
              <Table.Td>{order.destination}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Nom du fournisseur</Table.Td>
              <Table.Td>{order.supplier_name}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Code filiale du fournisseur</Table.Td>
              <Table.Td>{order.supplier_branch_code}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Segment CTA du fournisseur</Table.Td>
              <Table.Td>{order.supplier_cta_segment}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Direction pilote</Table.Td>
              <Table.Td>{order.pilot_direction}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Pôle pilote</Table.Td>
              <Table.Td>{order.pilot_pole}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Unité pilote</Table.Td>
              <Table.Td>{order.pilot_unit}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Centre pilote</Table.Td>
              <Table.Td>{order.pilot_center}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Code saisisseur commande/appel</Table.Td>
              <Table.Td>{order.order_creator_code}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>libellé Saisisseur commande/appel</Table.Td>
              <Table.Td>{order.order_creator_label}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Nom de l'acheteur</Table.Td>
              <Table.Td>{order.buyer_name}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Demandeur de besoin</Table.Td>
              <Table.Td>{order.need_requester}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Destinataire livraison commande/appel</Table.Td>
              <Table.Td>{order.delivery_recipient}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Direction d'entrée</Table.Td>
              <Table.Td>{order.entry_direction}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Direction du prescripteur</Table.Td>
              <Table.Td>{order.prescriber_direction}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Etablissement prescripteur commande/appel</Table.Td>
              <Table.Td>{order.prescriber_establishment}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Centre du prescripteur</Table.Td>
              <Table.Td>{order.prescriber_center}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Libellé du centre du prescripteur</Table.Td>
              <Table.Td>{order.prescriber_center_label}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Direction CDP</Table.Td>
              <Table.Td>{order.cdp_direction}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Direction d'imputation</Table.Td>
              <Table.Td>{order.imputation_direction}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Pôle d'imputation</Table.Td>
              <Table.Td>{order.imputation_pole}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Unité d'imputation</Table.Td>
              <Table.Td>{order.imputation_unit}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Centre d'imputation</Table.Td>
              <Table.Td>{order.imputation_center}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Facture reçue</Table.Td>
              <Table.Td>{order.invoice_received}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Facture bloquée</Table.Td>
              <Table.Td>{order.invoice_blocked}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Numéro de ligne de commande</Table.Td>
              <Table.Td>{order.order_line_number}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Description de la ligne de commande</Table.Td>
              <Table.Td>{order.order_line_description}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Date de création de la ligne de commande</Table.Td>
              <Table.Td>{order.order_line_creation_date && formatDate(order.order_line_creation_date)}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>CTA de la ligne de commande</Table.Td>
              <Table.Td>{order.order_line_cta}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Quantité commandée</Table.Td>
              <Table.Td>{order.ordered_quantity}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Prix unitaire</Table.Td>
              <Table.Td>{order.unit_price}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Numéro de ligne de livraison</Table.Td>
              <Table.Td>{order.delivery_line_number}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Numéro de ligne d'imputation</Table.Td>
              <Table.Td>{order.imputation_line_number}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Clé d'imputation de la commande</Table.Td>
              <Table.Td>{order.order_imputation_key}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Montant commandé</Table.Td>
              <Table.Td>{order.ordered_amount}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Montant reçu</Table.Td>
              <Table.Td>{order.received_amount}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Montant HT facturé</Table.Td>
              <Table.Td>{order.invoiced_amount}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Ecart de facturation</Table.Td>
              <Table.Td>{order.invoicing_discrepancy}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>Reste à récéptionné</Table.Td>
              <Table.Td>{order.remaining_to_receive}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>CAP potentielle</Table.Td>
              <Table.Td>{order.potential_cap}</Table.Td>
            </Table.Tr>
          </Table.Tbody>
        </Table>
      </ScrollArea>
    </Modal>
  );
};

export default DisplayOrder;
